import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiInstagram, FiMail, FiPhone, FiChevronDown, FiGlobe } from 'react-icons/fi';
import { FaFacebook, FaTiktok, FaWhatsapp } from 'react-icons/fa';
import './Contact.css';

function Contact() {
    const [activeSection, setActiveSection] = useState(null);
    const [language, setLanguage] = useState('en'); // 'en' default, toggles to 'ar'
    const [formData, setFormData] = useState({ name: '', email: '', message: '' });
    const [formStatus, setFormStatus] = useState(''); // 'sending', 'success', 'error'

    const contactInfo = {
        phone: '01112659808',
        email: 'wallz.egy@gmail.com',
        instagram: 'https://www.instagram.com/wallz_eg/',
        facebook: 'https://www.facebook.com/profile.php?id=61578285524597',
        tiktok: 'https://www.tiktok.com/@wallz.eg'
    };

    const handleWhatsApp = () => {
        window.open(`https://wa.me/2${contactInfo.phone}`, '_blank');
    };

    const toggleSection = (section) => {
        setActiveSection(activeSection === section ? null : section);
    };

    const toggleLanguage = () => {
        setLanguage(language === 'ar' ? 'en' : 'ar');
    };

    const handleFormChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        setFormStatus('sending');

        // Create mailto link as fallback
        const subject = language === 'ar' ? 'رسالة من موقع WallZ' : 'Message from WallZ Website';
        const body = `Name: ${formData.name}%0D%0AEmail: ${formData.email}%0D%0A%0D%0AMessage:%0D%0A${formData.message}`;
        const mailtoLink = `mailto:wallz.egy@gmail.com?subject=${encodeURIComponent(subject)}&body=${body}`;

        // Open mailto link
        window.location.href = mailtoLink;

        // Reset form and show success
        setTimeout(() => {
            setFormData({ name: '', email: '', message: '' });
            setFormStatus('success');
            setTimeout(() => setFormStatus(''), 3000);
        }, 500);
    };

    const sections = [
        {
            id: 'about',
            titleAr: 'من نحن',
            titleEn: 'About Us',
            contentAr: 'إحنا WallZ، براند مصري بدأ سنة 2025. بنقدّم بوسترات وتصاميم معمولة بعناية، ونهتم بالجودة والتفاصيل من أول الفكرة لحد ما المنتج يوصلّك. هدفنا نطلع حاجة تعجبنا قبل ما تعجبك، وحاجة تفضل معاك فترة طويلة وتعبر عن ذوقك.',
            contentEn: 'We are WallZ, an Egyptian brand founded in 2025. We create posters and designs with a strong focus on quality and details, from the idea to the final product. Our goal is to deliver pieces we\'re proud of and that reflect your taste.'
        },
        {
            id: 'privacy',
            titleAr: 'سياسة الخصوصية',
            titleEn: 'Privacy Policy',
            contentAr: 'إحنا بنحترم خصوصية عملائنا وبنحافظ على أي بيانات بتتشارك معانا. أي بيانات ممكن نجمعها زي الاسم، وسيلة التواصل، أو عنوان الشحن بنستخدمها بس علشان ننفّذ الطلب ونتواصل مع العميل، ومش بنبيعها ولا بنشاركها مع أي طرف تالت.',
            contentEn: 'We respect our customers\' privacy and are committed to protecting any personal information shared with us. Collected data such as name, contact details, or shipping address is used only for order processing and communication, and is never sold or shared with third parties.'
        },
        {
            id: 'product',
            titleAr: 'تفاصيل المنتج',
            titleEn: 'Product Details',
            contentAr: 'البوسترات بتكون مطبوعة على أكريليك عالي الجودة بدل الزجاج. الأكريليك أخف وزنًا، أقوى، وأكثر أمانًا ومش بيتكسر بسهولة. الألوان بتطلع أوضح ولمعتها أحسن. الطباعة ديجيتال بدقة عالية علشان أفضل تفاصيل. الفريم مش خشب، مصنوع من خامة متينة وعملية.',
            contentEn: 'Posters are printed on high-quality acrylic instead of glass. Acrylic is lighter, stronger, and safer, with high resistance to breaking. It provides clearer colors and a glossy finish. Digital printing is used to ensure high resolution and sharp details. Frames are not wooden and are made from durable materials.'
        },
        {
            id: 'terms',
            titleAr: 'الشروط والأحكام',
            titleEn: 'Terms & Conditions',
            contentAr: 'كل المنتجات مخصصة للاستخدام الشخصي فقط إلا لو تم الاتفاق على غير كده. كل التصاميم والمحتوى ملك لبراند WallZ، وممنوع النسخ أو إعادة البيع أو الاستخدام التجاري بدون إذن. الطلب بيتنفّذ بعد تأكيده، ومفيش إلغاء أو استرجاع بعد بدء التنفيذ. لو حصل أي خطأ من ناحيتنا، بنعدّل أو نعيد الشغل من غير تكلفة إضافية.',
            contentEn: 'All products are intended for personal use unless otherwise agreed. All designs and content are the property of WallZ. Copying, reselling, or commercial use without permission is prohibited. Orders cannot be canceled or refunded once execution has started. Any error on our side will be fixed or remade at no additional cost.'
        },
        {
            id: 'shipping',
            titleAr: 'الشحن',
            titleEn: 'Shipping Info',
            contentAr: 'الشحن متاح داخل مصر. مدة الشحن بتتراوح من 4 إلى 7 أيام بعد تأكيد الطلب، وممكن تزيد في بعض الحالات لأسباب خارج عن إرادتنا أو بسبب شركة الشحن. بنجهّز الطلبات بعناية علشان توصل بأفضل حالة. في حالة حدوث كسر أو تلف أثناء الشحن، يرجى التواصل معانا فور استلام الطلب، وحقك محفوظ وسيتم التعامل مع المشكلة.',
            contentEn: 'Shipping is available within Egypt. Delivery usually takes 4 to 7 days after order confirmation and may take longer due to reasons beyond our control or related to the shipping company. Orders are packed carefully to ensure safe delivery. If any damage or breakage occurs during shipping, please contact us immediately upon receiving the order.'
        },
        {
            id: 'returns',
            titleAr: 'سياسة الاسترجاع',
            titleEn: 'Returns Policy',
            contentAr: 'بما إن المنتجات بتتنفّذ حسب الطلب، مفيش إلغاء أو استرجاع بعد بدء التنفيذ. لو حصل أي خطأ من ناحيتنا، بنعدّل أو نعيد الشغل من غير تكلفة إضافية. في حالة وصول الطلب مكسور أو تالف، بنستلمه منك وبنقوم بتعويضك إما بمنتج بديل أو باسترجاع المبلغ. يشترط وجود فيديو واضح بعد الاستلام مباشرة يوضّح فيه التلف أو المشكلة، ويكون طلب التعويض خلال يومين من استلام الشحنة.',
            contentEn: 'Since products are made to order, cancellations or returns are not available once production starts. If there\'s an error from our side, we\'ll fix or remake the order at no extra cost. If the order arrives damaged or broken, we will collect it and compensate you with either a replacement or a refund. A clear video showing the damage must be provided immediately after delivery, and the compensation request must be made within 2 days of receiving the order.'
        }
    ];

    return (
        <div className="contact-page">
            <div className="contact-container">
                {/* Header Section with Language Toggle */}
                <motion.div
                    className="contact-header"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    <div className="header-top">
                        <span className="contact-subtitle">Legal & Information</span>
                        <motion.button
                            className="language-toggle"
                            onClick={toggleLanguage}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            <FiGlobe />
                            <span>{language === 'ar' ? 'EN' : 'AR'}</span>
                        </motion.button>
                    </div>

                    <h1 className="contact-title">
                        {language === 'ar' ? (
                            <>الخصوصية و <span className="accent">الشروط</span></>
                        ) : (
                            <>Privacy & <span className="accent">Policies</span></>
                        )}
                    </h1>

                    <p className="contact-description">
                        {language === 'ar'
                            ? 'كل ما تحتاج معرفته عن منتجاتنا، سياساتنا، وطريقة عملنا.'
                            : 'Everything you need to know about our products, policies, and how we work.'
                        }
                    </p>
                </motion.div>

                {/* Accordion Sections */}
                <div className="info-accordion">
                    {sections.map((section, index) => (
                        <motion.div
                            key={section.id}
                            className="accordion-item"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.08 }}
                        >
                            <button
                                className={`accordion-header ${activeSection === section.id ? 'active' : ''}`}
                                onClick={() => toggleSection(section.id)}
                            >
                                <div className="accordion-title">
                                    <span className="section-number">0{index + 1}</span>
                                    <span className="title-main">
                                        {language === 'ar' ? section.titleAr : section.titleEn}
                                    </span>
                                </div>
                                <motion.div
                                    className="chevron-icon"
                                    animate={{ rotate: activeSection === section.id ? 180 : 0 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    <FiChevronDown />
                                </motion.div>
                            </button>

                            <AnimatePresence>
                                {activeSection === section.id && (
                                    <motion.div
                                        className="accordion-content"
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={{ height: 'auto', opacity: 1 }}
                                        exit={{ height: 0, opacity: 0 }}
                                        transition={{ duration: 0.3, ease: 'easeInOut' }}
                                    >
                                        <div className={`content-wrapper ${language === 'ar' ? 'rtl' : 'ltr'}`}>
                                            <p className="content-text">
                                                {language === 'ar' ? section.contentAr : section.contentEn}
                                            </p>
                                        </div>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </motion.div>
                    ))}
                </div>

                {/* Contact Cards Grid */}
                <motion.div
                    className="contact-section-title"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.6 }}
                >
                    <h2>{language === 'ar' ? 'تواصل معنا' : 'Get in Touch'}</h2>
                </motion.div>

                <div className="contact-grid">
                    {/* Phone Card */}
                    <motion.a
                        href={`tel:${contactInfo.phone}`}
                        className="contact-card"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.7 }}
                        whileHover={{ y: -5 }}
                    >
                        <div className="card-icon">
                            <FiPhone />
                        </div>
                        <h3>{language === 'ar' ? 'الهاتف' : 'Phone'}</h3>
                        <p>{contactInfo.phone}</p>
                    </motion.a>

                    {/* Email Card */}
                    <motion.a
                        href={`mailto:${contactInfo.email}`}
                        className="contact-card"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.8 }}
                        whileHover={{ y: -5 }}
                    >
                        <div className="card-icon">
                            <FiMail />
                        </div>
                        <h3>{language === 'ar' ? 'البريد الإلكتروني' : 'Email'}</h3>
                        <p>{contactInfo.email}</p>
                    </motion.a>

                    {/* WhatsApp Card */}
                    <motion.button
                        onClick={handleWhatsApp}
                        className="contact-card whatsapp-card"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.9 }}
                        whileHover={{ y: -5 }}
                    >
                        <div className="card-icon">
                            <FaWhatsapp />
                        </div>
                        <h3>{language === 'ar' ? 'واتساب' : 'WhatsApp'}</h3>
                        <p>{language === 'ar' ? 'تواصل معنا' : 'Chat with us'}</p>
                    </motion.button>
                </div>

                {/* Contact Form Section */}
                <motion.div
                    className="form-section"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.9 }}
                >
                    <h2 className="form-title">
                        {language === 'ar' ? 'أرسل لنا رسالة' : 'Send Us a Message'}
                    </h2>
                    <p className="form-subtitle">
                        {language === 'ar'
                            ? 'لديك سؤال أو اقتراح؟ نحن هنا للمساعدة'
                            : 'Have a question or suggestion? We\'re here to help'
                        }
                    </p>

                    <form className="contact-form" onSubmit={handleFormSubmit}>
                        <div className="form-row">
                            <div className="form-group">
                                <label>{language === 'ar' ? 'الاسم' : 'Name'}</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleFormChange}
                                    required
                                    placeholder={language === 'ar' ? 'أدخل اسمك' : 'Enter your name'}
                                />
                            </div>
                            <div className="form-group">
                                <label>{language === 'ar' ? 'البريد الإلكتروني' : 'Email'}</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleFormChange}
                                    required
                                    placeholder={language === 'ar' ? 'أدخل بريدك الإلكتروني' : 'Enter your email'}
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <label>{language === 'ar' ? 'الرسالة' : 'Message'}</label>
                            <textarea
                                name="message"
                                value={formData.message}
                                onChange={handleFormChange}
                                required
                                rows="5"
                                placeholder={language === 'ar' ? 'اكتب رسالتك هنا...' : 'Write your message here...'}
                            ></textarea>
                        </div>
                        <motion.button
                            type="submit"
                            className="form-submit"
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                            disabled={formStatus === 'sending'}
                        >
                            {formStatus === 'sending'
                                ? (language === 'ar' ? 'جاري الإرسال...' : 'Sending...')
                                : (language === 'ar' ? 'إرسال' : 'Send Message')
                            }
                        </motion.button>
                        {formStatus === 'success' && (
                            <motion.p
                                className="form-success"
                                initial={{ opacity: 0, y: -10 }}
                                animate={{ opacity: 1, y: 0 }}
                            >
                                {language === 'ar'
                                    ? '✓ تم فتح تطبيق البريد الإلكتروني. يرجى إرسال الرسالة.'
                                    : '✓ Email app opened. Please send the message.'
                                }
                            </motion.p>
                        )}
                    </form>
                </motion.div>

                {/* Social Media Section */}
                <motion.div
                    className="social-section"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 1.0 }}
                >
                    <h2 className="social-title">
                        {language === 'ar' ? 'تابعنا على' : 'Follow Our Journey'}
                    </h2>
                    <div className="social-links">
                        <motion.a
                            href={contactInfo.instagram}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-link instagram"
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            <FiInstagram />
                            <span>Instagram</span>
                        </motion.a>

                        <motion.a
                            href={contactInfo.facebook}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-link facebook"
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            <FaFacebook />
                            <span>Facebook</span>
                        </motion.a>

                        <motion.a
                            href={contactInfo.tiktok}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-link tiktok"
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            <FaTiktok />
                            <span>TikTok</span>
                        </motion.a>
                    </div>
                </motion.div>

                {/* Decorative Background Elements */}
                <div className="contact-bg-glow"></div>
            </div>
        </div>
    );
}

export default Contact;
